// Main mapping functions for TaskWorkflows API
export {
  mapFormDataToTaskRequest,
  mapFormDataToUpdateRequest,
} from "./taskWorkflowsApiMappers";
